enum IndDirectorTaskGroups {
  IND_DSC_PROCUREMENT = 'IND_DSC_PROCUREMENT',
}

export enum IndDirectorTasks {
  SCHEDULE_MEET_WITH_DSC_AGENT = 'SCHEDULE_MEET_WITH_DSC_AGENT',
  MARK_MEETING_COMPLETE = 'MARK_MEETING_COMPLETE',
  MARK_DSC_FILING = 'MARK_DSC_FILING',
  MARK_DSC_RECEIVED = 'MARK_DSC_RECEIVED',
}
